<template>
  <div class="box">
    <div class="wish" @click="clickWish('yes')">
      <div class="text" :class="[yes_class]">
        本人願意參加賽馬會「智康健」腦退化檢測及社區支援計劃，讓我選擇之機構根據本人提供的資料聯絡本人。
      </div>
      <img v-show="yes" class="img" src="/assets/image/yes.png" />
      <img v-show="yes_active" class="img" src="/assets/image/yes-active.png" />
    </div>
    <div class="wish" @click="clickWish('no')">
      <div class="text" :class="[no_class]">
        本人不願意參加賽馬會「智康健」腦退化檢測及社區支援計劃，毋需聯絡本人跟進。
      </div>
      <img v-show="no" class="img" src="/assets/image/no.png" />
      <img v-show="no_active" class="img" src="/assets/image/no-active.png" />
    </div>
    <img class="preload" src="/assets/image/yes-active.png" alt="" aria-hidden="true" />
    <img class="preload" src="/assets/image/no-active.png" alt="" aria-hidden="true" />
  </div>
</template>

<script>
export default {
  name: "FollowUpWish",
  data() {
    return {
      yes: true,
      yes_active: false,
      no: true,
      no_active: false,
      yes_class: 'unselect',
      no_class: 'unselect',
    }
  },
  methods: {
    clickWish: function (option) {
      if (option === 'yes') {
        this.yes = this.no_active = false;
        this.yes_active = this.no = true;
        this.yes_class = 'selected';
        this.no_class = 'unselect';
        this.$emit('getIsWish', true);
      } else {
        this.yes_active = this.no = false;
        this.yes = this.no_active = true;
        this.no_class = 'selected';
        this.yes_class = 'unselect';
        this.$emit('getIsWish', false);
      }

    }
  }
}
</script>

<style scoped>
.box {
  display: flex;
  justify-content: center;
  text-align: center;
  margin: clamp(0.25rem, 1vw, 0.5rem) auto clamp(1.25rem, 3vw, 2rem);
}

.wish {
  position: relative;
  width: 30%;
  margin: clamp(0.25rem, 1vw, 0.5rem) clamp(0.5rem, 1.5vw, 0.75rem);
  cursor: default;
}

.text {
  text-align: left;
  min-height: 100%;
  border-radius: 8px;
  padding: clamp(0.5rem, 1.25vw, 0.75rem) clamp(0.5rem, 1.25vw, 0.75rem) clamp(2rem, 3vw, 2.5rem);
  font-size: var(--ecs-font-md);
  line-height: 1.3;
  overflow-wrap: anywhere;
}

.img {
  width: clamp(2rem, 10vw, 4rem);
  position: absolute;
  bottom: clamp(-2rem, -3vw, -1.25rem);
  left: 50%;
  transform: translateX(-50%);
}

.preload {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
}

.unselect {
  color: #666666;
  border: #c9c9cc 3px solid;
}

.selected {
  color: #94c43b;
  border: #94c43b 3px solid;
}
</style>
